import { NotificationData } from "../NotificationData";

export class NotificationDeviationReminderData extends NotificationData {

  propertyID: string = "";
  deviationID: string = "";

  setup(data: any) {
    super.setup(data)
    this.type = NotificationData.types.DEVIATION_REMINDER;

    if(data.notificationData){
      this.propertyID = data.notificationData?.propertyID;
      this.deviationID = data.notificationData?.deviationID;
      
      this.title = data.notificationData?.title ?? "";
      this.body = data.notificationData?.body ?? "";
      this.redirectPath = `/properties/${this.propertyID}/tasks/${this.deviationID}`;
    }
  }
}